import { render, staticRenderFns } from "./CreditManagement.vue?vue&type=template&id=63a073e6&scoped=true&"
import script from "./CreditManagement.vue?vue&type=script&lang=js&"
export * from "./CreditManagement.vue?vue&type=script&lang=js&"
import style0 from "./CreditManagement.vue?vue&type=style&index=0&id=63a073e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a073e6",
  null
  
)

export default component.exports